<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
		[ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<app-loader *ngIf="!dataIsLoaded"></app-loader>
<section class="main-side-nav"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container my-dashboard-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>My Plan <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Dashboard'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Dashboard</h1>
			</div>
		</section>

		<app-suggested-next-steps *ngIf="dataIsLoaded"
			[myCategoriesBalance]="myCategoriesBalance"></app-suggested-next-steps>

		<h2 class="section-title">My Plan</h2>
		<section class="dashboard">
			<ng-container *ngFor="let category of myCategoriesBalance">
				<section *ngIf="dataIsLoaded && isNFZ==false || category.tabName !== 'financialsummaries'" class="{{category.class}}"
					id="{{category.id}}" [ngClass]="{active: chosenTab == category.tabName}"
					(click)="showTab(category.tabName, $event);">
					<div class="arrow-down"></div>
					<div class="data-icon">
						<div class="total-user-data">
							<div class="total-user-items-data">
								<div class="total-data-name">{{category.navTitle}}</div>
								<div *ngIf="category.navTitle !== 'Financial Summaries'" class="nav-item">
									{{category.itemCount + " items"}}
								</div>
								<div *ngIf="category.amount !== 0 && category.navTitle">
									<div class="total-data-count">{{category.amount |
										currency:'GBP':'symbol-narrow':'1.0'}}
									</div>
								</div>
							</div>
						</div>
						<span class="icon">
							<img *ngIf="category.tabName == 'assets'"
								src="../../assets/img/{{themeService.theme}}/assets.svg" alt="Assets">
							<img *ngIf="category.tabName == 'debts'"
								src="../../assets/img/{{themeService.theme}}/debts.svg" alt="Debts">
							<img *ngIf="category.tabName == 'dailyLife'"
								src="../../assets/img/{{themeService.theme}}/daily-life.svg" alt="Daily Life">
							<img *ngIf="category.tabName == 'digitalLife'"
								src="../../assets/img/{{themeService.theme}}/digital-life.svg" alt="Digital Life">
							<img *ngIf="category.tabName == 'wishes'"
								src="../../assets/img/{{themeService.theme}}/wishes.svg" alt="Wishes">
							<img *ngIf="category.tabName == 'financialsummaries' && isNFZ==false"
								src="../../assets/img/{{themeService.theme}}/donut-chart.svg" alt="Financial Summary">
						</span>
					</div>
				</section>
			</ng-container>
		</section>
		<!-- Grey boxes -->
		<section class="gray-data-item-boxes" [ngClass]="{assetsPositionClass: chosenTab =='assets',
						debtsPositionClass: chosenTab =='debts', 
						dailylifePositionClass: chosenTab =='dailylife', 
						wishesPositionClass: chosenTab =='wishes'}">
			<div class="items-data">
				<div class="item-data" *ngFor="let section of categorySections; let n = index" (click)="goto(section)"
					[class.mobile-hidden-item]="n >= 4 && !mobileListExpanded">
					<div class="item-count">
						<span class="count">{{section["itemCount"]}}</span>
						<span class="x">x</span>
					</div>
					<div class="item-name">{{section["sectionName"]}}</div>
				</div>
				<div class="mobile-list-toggle" *ngIf="categorySections && categorySections.length > 4"
					(click)="mobileListExpanded = !mobileListExpanded">
					<span>
						{{ mobileListExpanded ? 'Show Less' : 'Show All' }}
						<i class="fa fas" [ngClass]="mobileListExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
					</span>
				</div>
			</div>
		</section>

	</section>
</section>

<app-scroll-top></app-scroll-top>